import { TableNode } from '@table-library/react-table-library';
import { useState } from 'react';
import { useTablesConfig } from 'store/state';
import { Table } from '..';
import { IMagellanTableProps } from '../table/Table';
import { MagellanColumn } from 'types/components/table/table.types';
import { getDefaultTableGridTemplateColumns } from 'utils/table/gridTemplateColumns.utils';
import './FooterTable.scss';

const FooterTable = <T extends TableNode>({
  ...props
}: IMagellanTableProps<T>) => {
  const tablesConfig = useTablesConfig();

  const [layoutChange] = useState(() =>
    getDefaultTableGridTemplateColumns(
      props.columns as MagellanColumn<TableNode>[]
    )
  );

  const footerDisplay = !!props.columns.find(c => !!c.footer);

  const isEmptyData = !props.data.nodes.length;

  const tableColumns = props.columns.map(({ footer, ...rest }) => rest);

  return (
    <div className='magellan-table-footer-wrapper'>
      <Table
        {...props}
        columns={tableColumns}
        layout={{
          fixedHeader: true,
          ...props.layout,
        }}
      />
      {footerDisplay && !isEmptyData && (
        <div
          className='magellan-table-footer'
          style={{
            gridTemplateColumns: props.id
              ? tablesConfig[props.id]?.grid
              : layoutChange,
          }}>
          {props.columns
            .filter(c => !c.hide)
            .map((c, k) => (
              <div key={k} className='magellan-table-footer-column'>
                {c.footer ?? ' '}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default FooterTable;
